export default class Drawer {
    constructor(api) {
        this.api = api;
        this.DrawerClass = null;
    }

    async init(instance) {
        if (!this.DrawerClass) {
            if (instance.data && instance.data.cdn && instance.data.cdn.js) {
                await this.api.util.loadJS(instance.data.cdn.js);
                // await this.api.util.loadJS(["http://localhost:8081/widget_drawer.js"]);
                // await this.api.util.loadJS(["https://cdn.oryxgaming.com/widget/agg_widgets/test-ml-v1/ingame/drawer/js/drawer.js"]);
            } else if (
                this.api.settings &&
                this.api.settings.nativeMobileApp &&
                this.api.settings.widgetsUrl &&
                this.api.settings.widgetsUrl.drawer &&
                this.api.settings.widgetsUrl.drawer.js
            ) {
                await this.api.util.loadJS([this.api.settings.widgetsUrl.drawer.js]);
            }

            if (instance.data && instance.data.cdn && instance.data.cdn.css) {
                 await this.api.util.loadCSS(instance.data.cdn.css);
                // await this.api.util.loadCSS(['http://localhost:63342/widgets/dist/leaderboard/css/leaderboard.css']);
                // await this.api.util.loadCSS(['https://cdn.oryxgaming.com/widget/agg_widgets/test-ml-v1/ingame/drawer/css/drawer.css']);
            } else if (
                this.api.settings &&
                this.api.settings.nativeMobileApp &&
                this.api.settings.widgetsUrl &&
                this.api.settings.widgetsUrl.drawer &&
                this.api.settings.widgetsUrl.drawer.css
            ) {
                await this.api.util.loadCSS([this.api.settings.widgetsUrl.drawer.css]);
            }

            
            this.api.drawer = {
                module: instance.module,
                instance: instance.instance,
                settings: instance.data.settings
            };
            this.DrawerClass = new window.Widget_drawer.default(instance.instance, this.api);
        }
    }
}
